import React from "react";
import { Link2, Mail, Globe, UserCheck, Shield } from "lucide-react";

export default function ConnectedAccounts() {
  const accounts = [
    { name: "Google", connected: true, icon: <Globe className="w-[12px] h-[12px] text-red-400" /> },
    { name: "Telegram", connected: true, icon: <Mail className="w-[12px] h-[12px] text-blue-400" /> },
    { name: "Twitter (X)", connected: false, icon: <UserCheck className="w-[12px] h-[12px] text-sky-400" /> },
    { name: "LinkedIn", connected: false, icon: <Shield className="w-[12px] h-[12px] text-blue-500" /> },
  ];

  return (
    <div className="p-3 text-white text-[0.7rem] space-y-3">
      {/* Header */}
      <h1 className="text-[0.75rem] font-semibold flex items-center gap-2 text-slate-200 mb-2 tracking-wide">
        <Link2 className="w-[14px] h-[14px] text-green-400" />
        Connected Accounts
      </h1>

      {/* Accounts List */}
      <div className="grid sm:grid-cols-2 gap-2">
        {accounts.map((acc, i) => (
          <div
            key={i}
            className={`flex items-center justify-between bg-slate-900/70 border border-slate-800 rounded-md p-2 transition ${
              acc.connected ? "border-green-700/60" : "hover:bg-slate-900/60"
            }`}
          >
            <div className="flex items-center gap-2 text-slate-300">
              {acc.icon}
              <span className="truncate">{acc.name}</span>
            </div>
            <button
              className={`px-2 py-[2px] rounded-full text-[0.65rem] font-semibold transition ${
                acc.connected
                  ? "bg-green-700/80 text-white"
                  : "bg-blue-700/80 hover:bg-blue-600"
              }`}
            >
              {acc.connected ? "Connected" : "Connect"}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
